import { Col } from '@guestyci/foundation/Layout';
import createStyles from '@guestyci/foundation/createStyles';
import FeatureToggleProvider from '@guestyci/feature-toggle-fe/FeatureToggleProvider';

import env from 'config/env';
import NavBar from 'app/module/NavBar';
import useInitPendo from 'app/hooks/pendo/useInitPendo';
import useSaveUserCookie from 'app/hooks/cookies/useSaveUserCookie';
import useLogoutWeakUsers from 'app/hooks/authorization/useLogoutWeakUsers';
import ModuleFederationApp from 'app/module/micro-frontend/ModuleFederationApp';
import TrialPeriodContainer from 'app/module/TrialPeriod/TrialPeriodContainer';
import { useAuthorizationContext } from 'app/module/Authorization/AuthorizationContainer';

const useStyles = createStyles(() => ({
  root: {
    height: '100%',
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    gridTemplateColumns: '100%',
  },
}));

interface IUserLayoutProps {
  children: React.ReactNode;
}

const UserLayout = ({ children }: IUserLayoutProps) => {
  const classes = useStyles();
  const { state } = useAuthorizationContext();

  useInitPendo();
  useSaveUserCookie();
  useLogoutWeakUsers();

  return (
    <FeatureToggleProvider env={env} accountId={state.accountId}>
      <Col className={classes.root}>
        <NavBar />
        {children}
        <TrialPeriodContainer />
        <ModuleFederationApp repositoryName="gfh-dynamic-pricing-page/LayoutDialogsContainer" />
      </Col>
    </FeatureToggleProvider>
  );
};

export default UserLayout;
